module.exports = __webpack_public_path__ + "img/Banner_CTST2.aa08e483.png";